import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../core/services/notification.service';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { ActionDataResult } from '../models/core/ActionDataResult';
import { KeyValueObject } from '../models/core/KeyValueObject';
import { YandexAddressDto } from '../models/address/yandex-address.dto';
import { filter, map, take, tap } from 'rxjs/operators';
import { NotificationType } from '../../core/services/notification-type';

@Injectable()
export class AddressService {

	protected controllerVersion = 1;
	protected controllerName = "address";

	constructor(
		public http: HttpClient,
		public notificationService: NotificationService
	) { }

	public addAddressOrCoordinatesByName(address: string,
		customerObjectId?: number,
		latitude?: number,
		longitude?: number,
		logMessage?: string,
		dadataTryCount: number = 1,
		suppressException: boolean = false): Observable<ActionDataResult<number>> {

		return this.http.post<ActionDataResult<number>>(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/add-address-or-coordinates-by-name`,
			{
				fullName: address,
				customerObjectId,
				latitude,
				longitude,
				logMessage,
				dadataTryCount,
				suppressException
			});
	}

	public getAddressByCoords(latitude: number, longitude: number): Observable<ActionDataResult<YandexAddressDto>> {
		return this.http.get<ActionDataResult<YandexAddressDto>>(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/get-address-by-coords?latitude=${latitude}&longitude=${longitude}`);
	}

	public getDepotAddressesLookup(): Observable<KeyValueObject[]> {
		return this.http
			.get<ActionDataResult<KeyValueObject[]>>(`${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/depot-addresses-lookup`)
			.pipe(
				tap(resp => {
					if (!resp.isSuccessful) {
						this.notificationService.error({
							title: 'Ошибка',
							message: resp.errorDescription,
							notificationType: NotificationType.SweetAlert
						});
					}
				}),
				take(1),
				filter(x => x.isSuccessful),
				map(x => x.data || [])
			);
	}
}